export const DEFAULT_DRIVER_STATUS_ACTIONS = {
    "-2": "manageDriverStatus_clockIn",
    "-1": "manageDriverStatus_clockOut",
    "-3": "manageDriverStatus_mealBreakBegin",
    "-4": "manageDriverStatus_mealBreakEnd"
  };
  